import { Badge, Tab, Tabs } from "@mui/material";
import React from "react";

interface IPageTab {
  id: string;
  title: string;
  badgeContent?: number;
  disabled?: boolean;
  hidden?: boolean;
}

interface IPageTabsProps {
  activeTabId: string;
  tabs: IPageTab[];
  changeTab: (tabId: string) => void;
}

export const PageTabs = (props: IPageTabsProps) => {
    const handleChangeViewTab = (
        _event: React.SyntheticEvent,
        newValue: string
    ) => {
        props.changeTab(newValue);
    };

    return (
        <Tabs value={props.activeTabId} onChange={handleChangeViewTab}>
            {props.tabs.map(
                (tab) =>
                    !tab.hidden && (
                        <Tab
                            key={tab.id}
                            label={
                                tab.badgeContent > 0
                                    ? (
                                        <Badge
                                            color="info"
                                            badgeContent={tab.badgeContent}
                                            sx={{
                                                span: {
                                                    top: "-3px",
                                                    right: "-4px",
                                                },
                                            }}
                                        >
                                            {tab.title}
                                        </Badge>
                                    )
                                    : (
                                        tab.title
                                    )
                            }
                            value={tab.id}
                            disabled={tab.disabled}
                        />
                    )
            )}
        </Tabs>
    );
};
